import { render } from "./GradeEdicao.vue?vue&type=template&id=683e780d&ts=true"
import script from "./GradeEdicao.vue?vue&type=script&lang=ts"
export * from "./GradeEdicao.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/GradeEdicao/GradeEdicao.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "683e780d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('683e780d', __exports__)) {
    api.reload('683e780d', __exports__)
  }
  
  module.hot.accept("./GradeEdicao.vue?vue&type=template&id=683e780d&ts=true", () => {
    api.rerender('683e780d', render)
  })

}


export default __exports__